import { createReducer } from 'redux-act';
import {
	fetchLeagueLadderSuccess,
	clearLadder
} from 'modules/actions';

export interface ILadder {
	id: number;
	team_id: number;
	username: string;
	first_name: string;
	last_name: string;
	value: number;
	country: string;
	league_id: number;
	event_id: number;
	overall_rank: number;
	overall_points: number;
	event_rank: number;
	event_points: number;
	previous_event_rank: number;
	previous_event_points: number;
	average_points: number;
	turbo_rider_free: number;
}

export interface ILadderReducer {
	ladder: ILadder[];
	next: boolean;
}

const initial_state = {
	ladder: [],
	next: false
};

export const ladder = createReducer<ILadderReducer>({}, initial_state)
	.on(fetchLeagueLadderSuccess, (state, payload: ILadderReducer) => ({
		...state,
		...payload
	}))
	.on(clearLadder, (state) => ({
		...initial_state
	}))
;